import { joinPaths } from "../../../util/join";
import { ScaffoldingData } from "../../ScaffoldingData";
import { ejsTemplateFile, EjsTemplateFileOptions } from "../EjsTemplateFile";

export function addEjsTemplateFile(
  data: ScaffoldingData,
  fileName: string,
  content: string,
  ejsData?: Record<string, any>,
  options?: EjsTemplateFileOptions,
) {
  data.files.set(
    joinPaths(data.currentDir, fileName),
    ejsTemplateFile(content, ejsData, options),
  );
}
